const firebaseConfig = {
    apiKey: "AIzaSyBLl8Nxf7WsX3DjMKmHvYtfNLm32QBxU00",
    authDomain: "healthcareassignment10.firebaseapp.com",
    projectId: "healthcareassignment10",
    storageBucket: "healthcareassignment10.appspot.com",
    messagingSenderId: "281208892844",
    appId: "1:281208892844:web:659eb97461e49979dc5e09"
};

export default firebaseConfig;